// extracted by mini-css-extract-plugin
module.exports = {"defaultPagination":"styles_defaultPagination__8FuIq"};